import { render, staticRenderFns } from "./ChooseRedemptionAmount.vue?vue&type=template&id=6e8c3026&scoped=true"
import script from "./ChooseRedemptionAmount.vue?vue&type=script&lang=js"
export * from "./ChooseRedemptionAmount.vue?vue&type=script&lang=js"
import style0 from "./ChooseRedemptionAmount.vue?vue&type=style&index=0&id=6e8c3026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c3026",
  null
  
)

export default component.exports